
// src/actions/login-history.js

import PermanentStore from './permanent-store'
import find from 'lodash/find'

const KEY = 'gambaApp.login_history'
const store = PermanentStore(KEY, [])

export default {
  get: store.get,
  set: (user)=> {
    if (!user.email.match(/demo.*@getgamba.com/)) // デモ用アカウントは履歴に残さない
      store.get((histories)=> {
        const item = find(histories, (item)=> item.email == user.email)
        if (!item) {
          histories.push({ email: user.email, name: user.name })
          store.set(histories)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/login-history.js